const PanelSection = ({ eyebrow, title, countLabel, children, footer }) => {
  return (
    <section className="panel-card intel-section">
      <div className="section-heading">
        <div className="intel-section__heading">
          {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
          {title ? <h3>{title}</h3> : null}
        </div>
        {countLabel ? <span className="status-pill status-pill--amber">{countLabel}</span> : null}
      </div>
      {children}
      {footer ? <p className="intel-footnote">{footer}</p> : null}
    </section>
  );
};

export default PanelSection;
